/*
 * Hedgeroe — "Load more" pagination for collection pages.
 * Added Sept 2026. Works with snippets/pagination-control.liquid.
 * Delete this file and revert that snippet to restore numbered pages.
 */
(function () {
  if (window.hedgeroeLoadMoreReady) return;
  window.hedgeroeLoadMoreReady = true;

  var GRID = '.collection-listing .product-list';
  var CARD = '.product-block';
  var busy = false;
  var observer = null;

  function closestBtn(el) {
    while (el && el.nodeType === 1) {
      if (el.hasAttribute && el.hasAttribute('data-load-more')) return el;
      el = el.parentElement;
    }
    return null;
  }

  function grid() {
    return document.querySelector(GRID);
  }

  function unveil(el) {
    try {
      if (window.lazySizes && window.lazySizes.loader && window.lazySizes.loader.unveil) {
        window.lazySizes.loader.unveil(el);
      }
    } catch (e) {}
  }

  /* The theme's lazy loader only tracks images present at page load, so any
     image we append has to be watched and revealed by us. */
  function watchLazyImages(scope) {
    var els = scope.querySelectorAll('.lazyload');
    var i;

    if (!('IntersectionObserver' in window)) {
      for (i = 0; i < els.length; i++) unveil(els[i]);
      return;
    }

    if (!observer) {
      observer = new IntersectionObserver(
        function (entries) {
          for (var j = 0; j < entries.length; j++) {
            if (entries[j].isIntersecting) {
              observer.unobserve(entries[j].target);
              unveil(entries[j].target);
            }
          }
        },
        { rootMargin: '800px 0px' }
      );
    }

    for (i = 0; i < els.length; i++) {
      if (els[i].getAttribute('data-lm-watched') === 'true') continue;
      els[i].setAttribute('data-lm-watched', 'true');
      observer.observe(els[i]);
    }
  }

  function setCount(n) {
    var el = document.querySelector('[data-load-more-shown]');
    if (el) el.textContent = n;
  }

  function stripAnimation(node) {
    node.removeAttribute('data-cc-animate');
    var nested = node.querySelectorAll('[data-cc-animate]');
    for (var i = 0; i < nested.length; i++) nested[i].removeAttribute('data-cc-animate');
  }

  function load(btn) {
    var url = btn.getAttribute('href');
    var list = grid();
    if (!url || !list) return;

    busy = true;
    btn.setAttribute('aria-busy', 'true');
    btn.innerHTML = btn.getAttribute('data-loading-label') || 'Loading&hellip;';

    fetch(url, { credentials: 'same-origin' })
      .then(function (res) {
        if (!res.ok) throw new Error('HTTP ' + res.status);
        return res.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var incoming = doc.querySelectorAll('.product-list ' + CARD);
        if (!incoming.length) throw new Error('no products in response');

        var seen = {};
        var existing = list.querySelectorAll(CARD + '[data-product-id]');
        var i;
        for (i = 0; i < existing.length; i++) {
          seen[existing[i].getAttribute('data-product-id')] = true;
        }

        var added = [];
        var frag = document.createDocumentFragment();
        for (i = 0; i < incoming.length; i++) {
          var id = incoming[i].getAttribute('data-product-id');
          if (id && seen[id]) continue;
          if (id) seen[id] = true;
          stripAnimation(incoming[i]);
          var copy = document.importNode(incoming[i], true);
          added.push(copy);
          frag.appendChild(copy);
        }
        list.appendChild(frag);

        for (i = 0; i < added.length; i++) watchLazyImages(added[i]);
        setCount(list.querySelectorAll(CARD).length);

        var nextBtn = doc.querySelector('[data-load-more]');
        var nextUrl = nextBtn ? nextBtn.getAttribute('href') : null;

        if (nextUrl) {
          btn.setAttribute('href', nextUrl);
          btn.innerHTML = btn.getAttribute('data-label') || 'Load more';
        } else if (btn.parentNode) {
          btn.parentNode.removeChild(btn);
        }
      })
      .catch(function () {
        /* Let the next click fall through to an ordinary page load. */
        btn.setAttribute('data-load-more-failed', 'true');
        btn.innerHTML = btn.getAttribute('data-label') || 'Load more';
      })
      .then(function () {
        busy = false;
        btn.removeAttribute('aria-busy');
      });
  }

  document.addEventListener(
    'click',
    function (event) {
      if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey) return;
      var btn = closestBtn(event.target);
      if (!btn) return;
      if (btn.getAttribute('data-load-more-failed') === 'true') return;
      event.preventDefault();
      event.stopPropagation();
      if (busy) return;
      load(btn);
    },
    true
  );
})();
